export default class WasteTippingService {
    uploadReceipts = (wasteId, files) => {
        const formData = new FormData();
        files.forEach((file) => formData.append("receipts[]", file));

        return axios.post(`/jobs/waste-tipping/${wasteId}/upload-receipts`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    };

    deleteReceipt = (wasteId, receiptId) => {
        return axios.delete(`/jobs/waste-tipping/${wasteId}/receipt/${receiptId}`);
    };

    rotateReceipt = (receiptId, rotation) => {
        return axios.post(`/jobs/waste-tipping/media/${receiptId}/rotate`, { rotation });
    };

    approveWasteTipping = (wasteId) => {
        return axios.post(`/jobs/waste-tipping/${wasteId}/approve`, null, {
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            },
        });
    };

    attachCompletedJobs = (wasteId) => {
        return axios.post(`/jobs/waste-tipping/${wasteId}/attach-completed-jobs`);
    };
    update = (providerId, tippingId, data) => {
        return axios.patch(`/providers/${providerId}/waste-tipping/${tippingId}/update`, data);
    }
}

